export const LanguageEnum = {
  pt: 1,
  en: 2,
};

export const LanguageTextEnum = {
  PT: "pt",
  EN: "en",
};
